export default __webpack_public_path__ + "static/media/Anjali Suresh1.56d44ccd.jpeg";